import { type Prize, WHEEL_PRIZES } from '../model/wheel.types';

/**
 * Make type guard that checks if a prize has a specific type.
 */
const makeIsPrizeType = <T extends WHEEL_PRIZES>(prizeType: T) => {
  return (prize: Prize): prize is Omit<Prize, 'type'> & { type: T } =>
    prize.type === prizeType;
};

export const isTicketPrize = makeIsPrizeType(WHEEL_PRIZES.TICKET);
export const isPremiumPrize = makeIsPrizeType(WHEEL_PRIZES.PREMIUM);
export const isPlaycoinPrize = makeIsPrizeType(WHEEL_PRIZES.PLAYCOIN);
export const isNotcoinPrize = makeIsPrizeType(WHEEL_PRIZES.NOT);
export const isPartnerPrize = makeIsPrizeType(WHEEL_PRIZES.PARTNER);
export const isTonPrize = makeIsPrizeType(WHEEL_PRIZES.TON);
export const isBoosterPlaycoinPrize = makeIsPrizeType(WHEEL_PRIZES.BOOSTER_PLAYCOIN);
export const isClickerPlaycoinPrize = makeIsPrizeType(WHEEL_PRIZES.CLICKER_PLAYCOIN);
export const isClickerXpPrize = makeIsPrizeType(WHEEL_PRIZES.CLICKER_XP);
